module.exports = __webpack_public_path__ + "ae3f595fc329b6b4bf4e97df46fd9c6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/ankur.jpg
// module id = 41
// module chunks = 0